import { LANGUAGE_LIST, type Language, type LanguageInfo, offeredLanguages } from "@bt/domain";
import { useSystemInfo } from "./system";

/**
 * The languages to offer in pickers, as the server says (drafts only where the host shows them),
 * in the order of `languages.json`. Before the server answers: all but drafts.
 */
export function useLanguages(): readonly LanguageInfo[] {
  return useSystemInfo()?.languages ?? offeredLanguages(false);
}

/** A language in its own name ("Deutsch"), or its code when the list doesn't have it. */
export function languageName(code: Language): string {
  return LANGUAGE_LIST.find((l) => l.code === code)?.name ?? code;
}
